const __WEBPACK_NAMESPACE_OBJECT__ = require("log-watcher-webpack-plugin");